import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import { Modal, ModalHeader, ModalBody, Col, Row } from "reactstrap";
// import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

import { customerCoBrowseAction } from "CONFIG/ActionFactory";

import ic_ellipse_selected from "ASSETS/Images/ic_check.svg";
import ic_ellipse from "ASSETS/Images/ic_eclipse.svg";
import { validateCobrowseCustomURL } from "UTILS/regexValidations";
import { CO_BROWSE_LAYOUT } from "UTILS/Constants";

import "./CustomerCoBrowse.less";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

import ic_layout_mobile_vertical from "ASSETS/Images/ic_mobile.svg";
import ic_layout_mobile_horizontal from "ASSETS/Images/ic_mobile_horizontal.svg";
import ic_layout_pc from "ASSETS/Images/ic_laptop.svg";
import ic_layout_tablet from "ASSETS/Images/ic_tablet.svg";

class TargetSiteSelectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      targetUrl: "",
      isCustomUrl: false,
      showURLSelectionModal: true,
      errorMsg: "",
      layoutCode: CO_BROWSE_LAYOUT.mobileVertical // default 3 is MobileVertical
    };
    this.handleLayoutCodeChange = this.handleLayoutCodeChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.cobrowseDetails !== this.props.cobrowseDetails) {
      if (this.props.cobrowseDetails.targetSites.length) {
        this.changeURLSelection(this.props.cobrowseDetails.targetSites[0].url, false);
      } else {
        this.changeURLSelection("", true);
      }
    }
  }

  changeURLSelection = (targetUrl, isCustomUrl) => {
    this.setState({
      targetUrl,
      isCustomUrl,
      errorMsg: ""
    });
  }

  changeURL = (event) => {
    this.setState({
      errorMsg: "",
      targetUrl: event.target.value
    });
  }

  // Change layout code
  handleLayoutCodeChange(event) {
    this.setState({
      layoutCode: event.target.value
    });
  }

  // Change layout code
  changeLayoutCodeSelection(selectionLayoutCode) {
    this.setState({
      layoutCode: selectionLayoutCode
    });
  }

  cancelCoBrowse = () => {
    customerCoBrowseAction.showTargetSiteSelectionModalAction(false);
  }

  handleBookCoBrowse = () => {
    if (this.props.isSnapshotRunning) {
      toastr.error(getMessage("CUSTOMER_CO_BROWSE_CANNOT_USE_WITH_SNAPSHOT"));
      customerCoBrowseAction.showTargetSiteSelectionModalAction(false);
      return;
    }

    if (this.state.targetUrl) {
      const isCustomURLValid = validateCobrowseCustomURL(this.state.targetUrl);
      if (isCustomURLValid === true) {
        this.props.handleBookCoBrowseSession(this.state.targetUrl, this.state.layoutCode);
      } else {
        this.setState({ errorMsg: isCustomURLValid });
      }
    } else {
      this.setState({ errorMsg: getMessage("ERROR_EMPTY_CO_BROWSE_URL") });
    }
  }

  renderTargetSiteSelector = () => {
    return (
      <Modal
        isOpen={this.state.showURLSelectionModal}
        id="targetSiteModal"
      >
        <ModalHeader>
          <div className="headerText">
            {getMessage("COBROWSE_URL_SELECTION")}
          </div>
        </ModalHeader>
        <ModalBody className="pt-0">
          <div style={{ marginTop: "1rem" }}>
            {getMessage("WEB_SITE")}
          </div>
          <div className="container">
            {
              this.props.cobrowseDetails.targetSites && this.props.cobrowseDetails.targetSites.map((targetSite) => (
                <div className="row pt-2" key={targetSite.id}>
                  {targetSite.url === this.state.targetUrl && !this.state.isCustomUrl
                    ? <img className="cursorPointer" src={ic_ellipse_selected} onClick={() => this.changeURLSelection("", false)} />
                    : <img className="cursorPointer" src={ic_ellipse} onClick={() => this.changeURLSelection(targetSite.url, false)} />}
                  <span
                    className="px-2 cursorPointer"
                    onClick={
                      targetSite.url === this.state.targetUrl ?
                        () => this.changeURLSelection("", false) :
                        () => this.changeURLSelection(targetSite.url, false)
                    }
                  >
                    {targetSite.label}
                  </span>
                </div>
              ))
            }
            {this.props.cobrowseDetails.allowCustomUrl && (
              <div className="row pt-2">
                {
                  this.state.isCustomUrl
                    ? <img className="cursorPointer" src={ic_ellipse_selected} onClick={() => this.changeURLSelection("", false)} />
                    : <img className="cursorPointer" src={ic_ellipse} onClick={() => this.changeURLSelection("", true)} />
                }
                <span className="px-2 cursorPointer" onClick={() => this.changeURLSelection("", true)}>
                  {this.props.cobrowseDetails.customUrlLabels &&
                    this.props.cobrowseDetails.customUrlLabels[0] &&
                    this.props.cobrowseDetails.customUrlLabels[0].label !== ""
                    ? this.props.cobrowseDetails.customUrlLabels[0].label
                    : getMessage("CUSTOM_URL")}
                </span>
              </div>
            )}
            {this.state.isCustomUrl && this.props.cobrowseDetails.allowCustomUrl && (
              <div className="row py-3">
                <Col>
                  <input
                    type="text"
                    className="inputFormControl form-control rounded-pill border w-100"
                    value={this.state.targetUrl.trim()}
                    onChange={this.changeURL}
                  />
                </Col>
              </div>
            )}

            {/* this.props.mutualEdit &&
              <div>
                <Row className="m-1"> </Row>
                <Row>
                  <Col className="col-md-5">
                    {getMessage("CO_BROWSE_MUTUAL_EDIT")}
                  </Col>
                  <div
                    className={"cursorDisabled col-md-1"}
                  >
                    <Switch
                      switchOn={this.props.presenterSelectMutualEdit}
                      toggleSwitch={(event)=>{this.props.onPresenterCoBrowseMutualEditSwitchClick(event)}}
                    />
                  </div>
                </Row>
              </div>
            */}

            {this.state.errorMsg && (
              <div className="d-flex justify-content-center">
                <span className="errors py-1 autoHeight">
                  {getMessage(this.state.errorMsg)}
                </span>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalBody className="pt-0" style={{ borderTop: "1px solid #dee2e6" }}>
          <div style={{ marginTop: "1rem" }}>
            {getMessage("LAYOUT_SELECT")}
          </div>
          <div className="container cursorPointer">
            <Row>
              <Col
                xl="6"
                lg="6"
                md="6"
                xs="12"
              >
                {/* First row of the first row: Smartphone vertical */}
                <div className="row pt-2" onClick={() => this.changeLayoutCodeSelection(CO_BROWSE_LAYOUT.mobileVertical)}>
                  <img src={this.state.layoutCode === CO_BROWSE_LAYOUT.mobileVertical ? ic_ellipse_selected : ic_ellipse} />
                  <img style={{ paddingLeft: "6px", paddingRight: "6px" }} src={ic_layout_mobile_vertical} />
                  <span>
                    {getMessage("LAYOUT_PHONE_VERTICAL")}
                  </span>
                </div>
              </Col>
              <Col
                xl="6"
                lg="6"
                md="6"
                xs="12"
              >
                {/* Second row of the first row: Smartphone horizontal */}
                <div className="row pt-2" onClick={() => this.changeLayoutCodeSelection(CO_BROWSE_LAYOUT.mobileHorizontal)}>
                  <img src={this.state.layoutCode === CO_BROWSE_LAYOUT.mobileHorizontal ? ic_ellipse_selected : ic_ellipse} />
                  <img style={{ paddingLeft: "6px", paddingRight: "6px" }} src={ic_layout_mobile_horizontal} />
                  <span>
                    {getMessage("LAYOUT_PHONE_HORIZONTAL")}
                  </span>
                </div>
              </Col>
            </Row>
            {/* <Row style={{ height: "10px" }}></Row> */}
            <Row>
              <Col
                xl="6"
                lg="6"
                md="6"
                xs="12"
              >
                {/* First column of the second row: PC */}
                <div className="row pt-2" onClick={() => this.changeLayoutCodeSelection(CO_BROWSE_LAYOUT.laptop)}>
                  <img src={this.state.layoutCode === CO_BROWSE_LAYOUT.laptop ? ic_ellipse_selected : ic_ellipse} />
                  <img style={{ paddingLeft: "6px", paddingRight: "6px" }} src={ic_layout_pc} />
                  <span>
                    {getMessage("LAYOUT_PC")}
                  </span>
                </div>
              </Col>
              <Col
                xl="6"
                lg="6"
                md="6"
                xs="12"
              >
                {/* Second column of the second row: Tablet */}
                <div className="row pt-2" onClick={() => this.changeLayoutCodeSelection(CO_BROWSE_LAYOUT.tablet)}>
                  <img src={this.state.layoutCode === CO_BROWSE_LAYOUT.tablet ? ic_ellipse_selected : ic_ellipse} />
                  <img style={{ paddingLeft: "6px", paddingRight: "6px" }} src={ic_layout_tablet} />
                  <span>
                    {getMessage("LAYOUT_TABLET")}
                  </span>
                </div>
              </Col>
            </Row>
          </div>
          <div className="d-flex justify-content-center" style={{ marginTop: "1.5rem" }}>
            <div className="col-md-4">
              <button
                className="rounded-pill w-100 btn customBtn"
                onClick={this.handleBookCoBrowse}
                type="button"
              >
                {getMessage("GO")}
              </button>
            </div>
            <div className="col-md-4">
              <button
                className="rounded-pill w-100 btn btn-decline"
                onClick={this.cancelCoBrowse}
                type="button"
              >
                {getMessage("CANCEL")}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    return (
      this.renderTargetSiteSelector()
    );
  }
}

export default TargetSiteSelectionModal;
